import {
  ActionListItem,
  ModalTrigger,
  Text,
  Link,
} from "@certn/cascadia-react";
import { ReactElement, JSXElementConstructor } from "react";

export function ActionListItemWithModal(props: {
  title: string;
  link: string;
  description: string;
  testID?: string;
  children: (
    close: () => void
  ) => ReactElement<any, string | JSXElementConstructor<any>>;
}) {
  const { testID = "action-list-modal-trigger-button" } = props;

  return (
    <ActionListItem
      displayAccessibility
      title={props.title}
      trailing={
        <ModalTrigger
          trigger={() => (
            <Link
              linkStyle="monochrome"
              textStyle="global/body-secondary"
              testID={testID}
            >
              {props.link}
            </Link>
          )}
        >
          {props.children}
        </ModalTrigger>
      }
    >
      <Text style="form/body-secondary" color="text-weak">
        {props.description}
      </Text>
    </ActionListItem>
  );
}
